/**
 * Validation
 */

import {validationRules} from "./validation-rules";
import {modal} from "./modal";

const validation = (() => {

    let _o = {
        inputs: null,
        recaptcha: null,
        selectors: {
            rules: "[data-validation-rules]",
            form: "[data-validation-form]"
        }
    };

    let status = [];

    const init = () => {
        validationRules.init();
        initEvents();
    };

    const initEvents = () => {
        const forms = document.querySelectorAll(_o.selectors.form);
        const inputs = document.querySelectorAll(_o.selectors.form + " " + _o.selectors.rules);

        forms.forEach((form) => {
            form.addEventListener("submit", submitForm);
        });

        inputs.forEach((input) => {
            input.addEventListener("change", validateInput);
            input.addEventListener("focusout", validateInput);
        });
    };

    const submitForm = () => {
        event.preventDefault();
        status = [];
        const form = event.target;
        const inputs = form.querySelectorAll(_o.selectors.rules);
        const errorContainer = form.querySelector('[data-form-error]');

        // let recaptcha = validateGrecaptcha();

        inputs.forEach((input) => validateInput(input));

        const submitBtn = form.querySelector('[type=submit]');

        setTimeout(() => {
            if (!status.includes(false)) {
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.dataset.originalText = submitBtn.textContent;
                    submitBtn.textContent = submitBtn.dataset.sendingText || 'Wysyłanie...';
                }

                grecaptcha.ready( () => {
                    grecaptcha
                      .execute('6LcipY4jAAAAAMfEyiQCdOnZRcOenAPf5jEG_Fy6', {action: 'submit'})
                      .then( (token) => {

                        const restoreSubmit = () => {
                            if (submitBtn) {
                                submitBtn.disabled = false;
                                submitBtn.textContent = submitBtn.dataset.originalText || 'Wyślij';
                            }
                        };

                        let request = new XMLHttpRequest();

                        request.upload.addEventListener('progress', (e) => {
                            if (e.lengthComputable) {
                                form.dispatchEvent(new CustomEvent('xhrUploadProgress', {
                                    detail: { loaded: e.loaded, total: e.total }
                                }));
                            }
                        });

                        request.upload.addEventListener('loadend', () => {
                            form.dispatchEvent(new CustomEvent('xhrUploadProgress', {
                                detail: { loaded: 1, total: 1 }
                            }));
                        });

                        request.onreadystatechange = function () {
                            if (request.readyState !== 4) return;

                            restoreSubmit();

                            if (request.status >= 200 && request.status < 300) {
                                const jsonResponse = JSON.parse(request.responseText);
                                const isResponseValid =
                                jsonResponse.status !== undefined && jsonResponse.status !== 'ERROR';

                                if (isResponseValid) {
                                setFormError(errorContainer, '');
                                formSubmitted(form, jsonResponse.modal);
                                } else {
                                let errorMessage = 'Unknown error. Please try again in a moment.';

                                if (jsonResponse.error) errorMessage = jsonResponse.error;

                                if (jsonResponse.errors) {
                                    const errors = [];

                                    jsonResponse.errors.forEach((error) => {
                                    errors.push(error.message);
                                    });

                                    errorMessage = errors.join(', ');
                                }

                                setFormError(errorContainer, errorMessage);
                                }
                            } else {
                                if (!request.response) return;

                                setFormError(errorContainer, 'Unknown error. Please try again in a moment.');
                            }
                            };
                        request.open("POST", form.getAttribute("action"), true);

                        const fileInput = form.querySelector("[type=file]");

                        const fd = new FormData(form);

                        fd.append('recaptcha', token);

                        if (fileInput)
                            Array.from(fileInput.files).forEach(file => {
                                fd.append("files[]", file)
                            })

                        form.dispatchEvent(new CustomEvent('xhrUploadStart'));
                        request.send(fd);
                      });
                });
            }
        });
    };

    const formSubmitted = (form, modalName) => {
        form.reset();

        let formSubmitted = form.querySelector("[data-form-submitted]");

        if (formSubmitted) {
            formSubmitted.classList.add("submitted");
            formSubmitted.setAttribute("role", "alert");
            const p = formSubmitted.querySelector("p");
            const actionElems = form.querySelectorAll("input, select, label, a, button");
            p.setAttribute("tabindex", "0");
            p.focus();

            actionElems.forEach(actionEl => actionEl.setAttribute("tabindex", "-1"));

            setTimeout(function(){
                formSubmitted.classList.remove("submitted");
                actionElems.forEach(actionEl => actionEl.removeAttribute("tabindex"));
            }, 5000);
        }

        if(modalName) {
            console.log(modalName);
            modal.openModal(document.getElementById(`modal-${modalName}`));
        }
    };

    const validateGrecaptcha = () => {
        _o.recaptcha = document.querySelector(".g-recaptcha");

        if (!_o.recaptcha || !grecaptcha)
            return true;

        const response = grecaptcha.getResponse();

        if (!response)
            setError(_o.recaptcha, "Pole jest wymagane");

        return response;

    };

    const recaptchaCallback = (response) => {
        if (response)
            setSuccess(_o.recaptcha);
    };

    const validateInput = (input) => {
        if (input.target)
            input = input.target;

        const type = input.getAttribute("type");

        // dont validate inputs witg parents display none (radioSwitcher module) but check 'hidden' (autocomplete)
        if(input.getClientRects().length === 0 && type !== 'hidden') return

        const rules = getValidationRules(input);
        let value, size = "";
        let isAnyError = false;
        let validateResponse;

        switch (type) {
            case "checkbox":
                value = input.checked;
                break;
            case "radio":
                value = input.getAttribute('name');
                break;
            case 'select':
                const temp = input.options[input.selectedIndex].value;
                value = temp === '0' ? '' : temp;
                break;
            case "file":
                value = []
                size = []
                const filesCount = input.files.length

                if (filesCount) {
                    Array.from(input.files).forEach( (file, index) => {
                        value.push(file.type)
                        size.push(file.size)
                    })
                }
                break;
            default:
                value = input.value;
        }

        for (let i = 0; i < rules.length; i++) {
            let currentRule = validationRules.returnValidationRule(rules[i]);
            validateResponse = currentRule(value, type);

            if (validateResponse.error) {
                isAnyError = true;
                break;
            } else {
                isAnyError = false;
            }
        }

        status.push(!isAnyError);

        if (isAnyError) {
            setError(input, validateResponse.msg);
        } else {
            setSuccess(input);
        }
    };

    const getValidationRules = (element) => {
        let data = element.dataset.validationRules;
        return data.split(',');
    };

    const setError = (element, msg) => {
        const type = element.getAttribute('type');
        const container = type !== 'radio' ? element.parentNode : element.closest('fieldset')

        if (container.classList.contains("error")) {
            const alert = container.querySelector("small");
            alert.innerHTML = msg;
        } else {
            container.classList.add("error");

            let alert = document.createElement("small");
            alert.setAttribute("role", "alert");
            alert.innerHTML = msg;
            container.appendChild(alert);
        }
    };

    const setSuccess = (element) => {
        const container = element.parentNode;
        const alert = container.querySelector("small");
        if (alert)
            container.removeChild(alert);

        container.classList.remove("error");
    };

    const setFormError = (messageContainer, message) => {
        const isParagraph = messageContainer.querySelector('p');

        if (isParagraph) {
            isParagraph.innerText = message;
        } else {
            const paragraph = document.createElement('p');
            const text = document.createTextNode(message);
            paragraph.appendChild(text);
            messageContainer.appendChild(paragraph);
        }
    };

    return {
        init: init,
        recaptchaCallback: recaptchaCallback
    };
})();

export {validation}
